/* NUVRA — încărcare automată a produselor în colecții (sections/nuvra-collection-full).
 * Paginarea reală rămâne în HTML (Google, fără JavaScript); loturile următoare vin prin Section Rendering API,
 * în ordinea sortării curente. Cu filtrele NUVRA active (assets/nuvra-filters.js) lista e gestionată de filtre.
 * La „Back” din pagina de produs se refac loturile încărcate și poziția produsului apăsat. */
(() => {
  'use strict';
  const grid = document.querySelector('[data-nvis-grid]');
  if (!grid) return;
  const root = grid.closest('.nuvra-page-root') || document.body;
  const pages = document.querySelector('.nc-pages');
  const sectionId = grid.dataset.section;
  const startPage = Number(grid.dataset.page) || 1;
  const totalPages = Number(grid.dataset.pages) || 1;
  const firstNext = grid.dataset.next || '';
  const MARGIN = 1400;
  let page = startPage, next = firstNext, busy = false, paused = false, failed = false, epoch = 0;

  const keyOf = (a) => { try { return new URL(a.getAttribute('href'), location.href).pathname; } catch (e) { return a.getAttribute('href'); } };
  const seen = new Set();
  const track = () => { seen.clear(); grid.querySelectorAll('a.nvk__link[href]').forEach((a) => seen.add(keyOf(a))); };
  track();

  // tema de bază derulează pagina în .page-wrapper, nu în fereastră
  const scroller = (() => { const w = grid.closest('.page-wrapper'); return w && /(auto|scroll)/.test(getComputedStyle(w).overflowY) ? w : null; })();
  const viewTop = () => (scroller ? scroller.getBoundingClientRect().top : 0);
  const viewBottom = () => (scroller ? scroller.getBoundingClientRect().bottom : innerHeight);

  root.classList.add('nvis-js');
  const sentinel = document.createElement('div');
  sentinel.className = 'nvis-sentinel'; sentinel.setAttribute('aria-hidden', 'true');
  const box = document.createElement('div');
  box.className = 'nvis'; box.setAttribute('role', 'status'); box.setAttribute('aria-live', 'polite');
  (pages || grid).after(sentinel, box);

  function show(state) {
    box.hidden = state === 'hidden' || (state === 'idle' && !next) || totalPages <= 1 && state !== 'error';
    if (state === 'loading') box.innerHTML = '<span class="nvis__row"><span class="nvis__spin" aria-hidden="true"></span>Se încarcă mai multe produse…</span>';
    else if (state === 'error') box.innerHTML = '<span>Nu am putut încărca următoarele produse.</span><button type="button" class="nvis-retry" data-nvis-retry>Încearcă din nou</button>';
    else if (state === 'done') box.innerHTML = '<p class="nvis-end">Ai descoperit toate produsele din această colecție.</p>';
    else box.innerHTML = '';
  }

  // un lot = cardurile din grila paginii cerute; produsele deja afișate nu se adaugă a doua oară
  async function fetchPage(url) {
    const u = new URL(url, location.origin);
    u.searchParams.set('section_id', sectionId);
    const r = await fetch(u, { credentials: 'same-origin' });
    if (!r.ok) throw new Error('HTTP ' + r.status);
    const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
    const g = doc.querySelector('[data-nvis-grid]');
    if (!g) throw new Error('Grila lipsește');
    return { cards: [...g.children], page: Number(g.dataset.page) || 0, next: g.dataset.next || '' };
  }
  function append(cards) {
    const frag = document.createDocumentFragment();
    cards.forEach((el) => {
      const a = el.querySelector && el.querySelector('a.nvk__link[href]');
      if (!a) return;
      const k = keyOf(a);
      if (seen.has(k)) return;
      seen.add(k); frag.appendChild(document.importNode(el, true));
    });
    grid.appendChild(frag);
  }
  async function load() {
    if (busy || paused || failed || !next) return;
    busy = true; const mine = epoch; show('loading');
    try {
      const res = await fetchPage(next);
      if (mine !== epoch) return;
      append(res.cards); page = res.page || page + 1; next = res.next;
      busy = false; show(next ? 'idle' : 'done');
      requestAnimationFrame(check);
    } catch (e) {
      if (mine !== epoch) return;
      busy = false; failed = true; show('error');
    }
  }
  const near = () => sentinel.getBoundingClientRect().top - viewBottom() < MARGIN;
  function check() { if (!busy && !paused && !failed && next && near()) load(); }

  box.addEventListener('click', (e) => { if (e.target.closest('[data-nvis-retry]')) { failed = false; load(); } });
  if ('IntersectionObserver' in window) {
    new IntersectionObserver((es) => { if (es.some((x) => x.isIntersecting)) check(); }, { root: scroller, rootMargin: '0px 0px ' + MARGIN + 'px 0px' }).observe(sentinel);
  }
  let ticking = false;
  (scroller || window).addEventListener('scroll', () => { if (ticking) return; ticking = true; requestAnimationFrame(() => { ticking = false; check(); }); }, { passive: true });

  // filtrele NUVRA înlocuiesc grila: pauză cât sunt active; la ștergerea lor grila revine la primul lot
  document.addEventListener('nv:filters', (e) => {
    epoch++; busy = false; failed = false;
    if (e.detail && e.detail.active) { paused = true; show('hidden'); return; }
    paused = false; page = startPage; next = firstNext; track(); show('idle'); requestAnimationFrame(check);
  });

  // poziția pentru „Back”: lotul curent și produsul apăsat, per URL (sortare și filtre incluse)
  // cheia se calculează la click: filtrele NUVRA schimbă URL-ul (nv_*) fără reîncărcare
  const keyNow = () => 'nvis:' + location.pathname + location.search;
  grid.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    const card = a.closest('.nvk') || a;
    try { sessionStorage.setItem(keyNow(), JSON.stringify({ page, href: keyOf(a), offset: Math.round(card.getBoundingClientRect().top - viewTop()), filtered: paused, t: Date.now() })); } catch (err) {}
  });
  function place(s) {
    const a = [...grid.querySelectorAll('a.nvk__link[href]')].find((x) => keyOf(x) === s.href);
    if (!a) return;
    const card = a.closest('.nvk') || a;
    const delta = card.getBoundingClientRect().top - viewTop() - s.offset;
    (scroller || document.scrollingElement).scrollTop += delta;
  }
  async function restore(s) {
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    if (s.filtered) {
      const onFilters = (e) => { if (e.detail && e.detail.active) { document.removeEventListener('nv:filters', onFilters); requestAnimationFrame(() => place(s)); } };
      document.addEventListener('nv:filters', onFilters);
      return;
    }
    if (s.page > page && next) {
      busy = true; show('loading');
      try {
        const urls = [];
        for (let n = page + 1; n <= Math.min(s.page, totalPages); n++) { const u = new URL(firstNext, location.origin); u.searchParams.set('page', n); urls.push(u.pathname + u.search); }
        const results = await Promise.all(urls.map(fetchPage));
        results.forEach((res) => { append(res.cards); page = res.page || page + 1; next = res.next; });
        busy = false; show(next ? 'idle' : 'done');
      } catch (e) { busy = false; failed = true; show('error'); }
    }
    requestAnimationFrame(() => { place(s); requestAnimationFrame(check); });
  }

  show('idle');
  let saved = null;
  try { saved = JSON.parse(sessionStorage.getItem(keyNow()) || 'null'); } catch (e) {}
  const nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
  if (saved && nav.type === 'back_forward' && Date.now() - saved.t < 3600 * 1000) restore(saved);
  else requestAnimationFrame(check);
  // pagina restaurată din memoria browserului (bfcache) are deja loturile și poziția
  addEventListener('pageshow', (e) => { if (e.persisted) requestAnimationFrame(check); });
})();
